import { render, staticRenderFns } from "./TipoGastoForm.vue?vue&type=template&id=7ce51893&"
import script from "./TipoGastoForm.vue?vue&type=script&lang=js&"
export * from "./TipoGastoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports